// useGetQuotes
import {useApi} from 'hooks';
import {quoteBindAxios} from 'lib/quoteBind';
import {QB_CANCELLATION_REASONS} from 'lib/quoteBind/queryKeys';

async function getCancellationReasons(productCode, external) {
  if (!productCode) {
    throw new Error('useGetCancellationReasons: productCode is required');
  }

  let apiUrl = `products/${productCode}/cancellationReasons`;

  if (external) {
    apiUrl = apiUrl.concat(`?external=${external}`);
  }

  const response = await quoteBindAxios.get(apiUrl);
  return response.data;
}

export function useGetCancellationReasons(productCode, external, options) {
  return useApi([QB_CANCELLATION_REASONS, productCode, external], async (productCode) => await getCancellationReasons(productCode, external), {
    cacheTime: 60 * 60 * 1000,
    ...options,
  });
}
